import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions } from '@mui/material';
import { ReactComponent as ConfirmationIcon } from '../../../assets/icons/Correct.svg';
import GhostButton from '../button/GhostButton';
import PrimaryButton from '../button/PrimaryButton';
import { BodyText, Subheading } from '../typography/PrimaryTypography';

/**
 * A global modal confirming an action.
 * @param {boolean} open The display state of the modal.
 * @param {string} title The header text of the modal.
 * @param {string} description The additional descriptive text of the action.
 * @param {string} confirm_button_text The text to add to the confirming button.
 * @param {void} handleCloseModal Handler to close the modal.
 * @param {void} handleConfirm Function to confirm from parent.
 * @returns {JSX.Element}
 */
const ConfirmationModal = ({
  open,
  title,
  description,
  confirm_button_text,
  confirm_loading,
  handleCloseModal,
  handleConfirm
}: {
  open: boolean;
  title: string;
  description: string;
  confirm_button_text: string;
  confirm_loading: boolean;
  handleCloseModal: () => void;
  handleConfirm: () => void;
}) => {
  const handleConfirmClick = async () => {
    await handleConfirm();
    handleCloseModal();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal}>
      <Subheading weight="Bold" sx={{ m: 2 }}>
        {title}
      </Subheading>
      <DialogContent>
        <BodyText id="explainer">{description}</BodyText>
        <DialogActions sx={{ mt: 2 }}>
          <GhostButton dark onClick={handleCloseModal}>
            Cancel
          </GhostButton>
          <PrimaryButton
            loading={confirm_loading}
            startIcon={
              <ConfirmationIcon
                height={25}
                width={25}
                fill="none"
                stroke="currentColor"
                strokeWidth={6}
              />
            }
            onClick={async () => {
              await handleConfirmClick();
            }}
            palette_color="success"
          >
            {confirm_button_text}
          </PrimaryButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
